import { ref } from "vue";

export const useRemovalConfirmation = () => {
  const open = ref(false);
  const resolveRemoval = ref<((value: boolean) => void) | null>(null);

  const confirmRemoval = () =>
    new Promise<boolean>((resolve) => {
      resolveRemoval.value = resolve;
      open.value = true;
    });

  const onConfirm = () => {
    open.value = false;
    resolveRemoval.value?.(true);
    resolveRemoval.value = null;
  };

  const onCancel = () => {
    open.value = false;
    resolveRemoval.value?.(false);
    resolveRemoval.value = null;
  };

  return {
    open,
    confirmRemoval,
    onConfirm,
    onCancel,
  };
};
